import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import './LandingPage.css'

export default function LandingPage() {
  const navigate = useNavigate()
  const { signInAsGuest } = useAuth()
  const [currentSlide, setCurrentSlide] = useState(0)

  const features = [
    {
      title: "Accessible to All Skill Levels",
      description: "Stronger players still have an advantage, but the dynamic board introduces variance and recovery opportunities, allowing less experienced players to compete and win individual games."
    },
    {
      title: "Suitable for Real-Money Tournaments",
      description: "The reduced impact of precomputation and external help enables a competitive environment that can support fair, real-money online tournaments."
    },
    {
      title: "High Replayability",
      description: "Randomized square placement and escalating board activity ensure that matches do not repeat the same patterns or openings."
    }
  ]

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % features.length)
    }, 4000) // Change slide every 4 seconds

    return () => clearInterval(timer)
  }, [features.length])

  const handleGuestLogin = async () => {
    try {
      await signInAsGuest()
    } catch (error) {
      console.error('Guest login failed:', error)
    }
  }

  return (
    <div className="landing-page">
      <div className="landing-content">
        <div className="landing-logo">
          <img src="/images/logo/finallogosquare.png" alt="RiftChess" className="landing-logo-img" />
        </div>

        <h1 className="landing-title">RiftChess</h1>
        <p className="landing-subtitle">The ultimate chess experience</p>

        {/* Features Slider */}
        <div className="features-slider">
          <div className="features-container">
            <div className="features-track">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className={`feature-slide ${index === currentSlide ? 'active' : ''}`}
                >
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation buttons */}
          <button
            className="nav-button nav-button-left"
            onClick={() => setCurrentSlide(currentSlide === 0 ? features.length - 1 : currentSlide - 1)}
          >
            &lt;
          </button>
          <button
            className="nav-button nav-button-right"
            onClick={() => setCurrentSlide((currentSlide + 1) % features.length)}
          >
            &gt;
          </button>
        </div>

        <div className="landing-actions">
          <button
            className="landing-button primary"
            onClick={() => navigate('/auth')}
          >
            Enter the Rift
          </button>

          <button
            className="landing-button outline"
            onClick={handleGuestLogin}
          >
            Try it Out
          </button>
        </div>
      </div>
    </div>
  )
}
